export default "__VITE_ASSET__R612Nzny__"